<template>
    <img
      alt="Certifications"
      class="h-20 w-auto mx-auto sm:mx-0"
      src="/assets/certifications.webp"
      width="158"
      height="48"
    >
</template>
